import { client } from "./client";
import axios from "axios";

// Create a separate client for public endpoints (no authentication)
const publicClient = axios.create({
  baseURL: process.env.NODE_ENV === 'development' 
    ? '/api/v1/public/' 
    : `${process.env.VUE_APP_FLOWIT_URL}/api/v1/public/`,
  timeout: 30000,
  headers: { 
    "Application-Name": `${process.env.VUE_APP_APP_NAME || 'FlowIt'}Web`,
    "Content-Type": "application/json"
  }
});

export default {
  // Authenticated endpoints (for authenticated users)
  index(params = {}) {
    return client.get("paylinks", { params });
  },

  show(id) {
    return client.get(`paylinks/${id}`);
  },

  create(paylink) {
    return client.post("paylinks", { paylink });
  },

  update(id, paylink) {
    return client.put(`paylinks/${id}`, { paylink });
  },

  destroy(id) {
    return client.delete(`paylinks/${id}`);
  },

  // Public endpoints (no authentication required)
  getPublicPaylink(uuid) {
    return publicClient.get(`paylinks/${uuid}`);
  },

  processPayment(uuid, paymentData) {
    return publicClient.post(`paylinks/${uuid}/pay`, paymentData);
  }
};